export default "__VITE_ASSET__22434534__"